import { styles } from "@repo/helpers";
import React from "react";

import type { ButtonProps } from "./types";

import { Spinner } from "../spinner";
import style from "./style.module.scss";
import { ButtonTypes } from "./types";

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(props, ref) {
	/**
	 * Concatenate all the class names based on the button
	 * type and the class name provided
	 */
	function getClassName() {
		const { className, disabled, types, size, fullWidth, color } = props;

		const classes = [className, style.btn];
		classes.push(disabled && style.disabled);
		classes.push(fullWidth && style.fullWidth);

		const typeClasses = (types ?? []).map(getTypesClass);
		classes.push(...typeClasses);
		classes.push(getColorClass());
		classes.push(getSizeClass());

		return styles(...classes);

		function getTypesClass(type: ButtonTypes) {
			switch (type) {
				case ButtonTypes.Primary:
					return style.btnPrimary;
				case ButtonTypes.Danger:
					return style.btnDanger;
				case ButtonTypes.Green:
					return style.btnGreen;
				case ButtonTypes.Circle:
					return style.btnCircle;
				case ButtonTypes.Icon:
					return style.btnIcon;
				case ButtonTypes.Text:
					return style.btnText;
				case ButtonTypes.Warning:
					return style.btnDarkYellow;
				case ButtonTypes.Outline:
					return style.outline;
			}
		}

		function getColorClass() {
			switch (color) {
				case "lightBlue":
					return style.btnLightBlue;
				case "darkBlue":
					return style.btnPrimary;
				case "green":
					return style.btnGreen;
				case "darkGreen":
					return style.btnDarkGreen;
				case "darkYellow":
					return style.btnDarkYellow;
				case "red":
					return style.btnDanger;

				default:
					return "";
			}
		}

		function getSizeClass() {
			switch (size) {
				case "large":
					return style.btnLg;
				case "medium":
					return style.btnMd;
				case "small":
					return style.btnXs;
				default:
					return "";
			}
		}
	}

	const {
		title,
		type = "button",
		disabled,
		tabIndex,
		children,
		loading,
		className,
		fullWidth,
		color,
		types,
		size,
		...rest
	} = props;
	return (
		<button
			ref={ref}
			className={getClassName()}
			title={title}
			type={type}
			disabled={disabled || loading}
			tabIndex={tabIndex}
			{...rest}
		>
			<>
				{loading && (
					<span className={style.spinnerContainer}>
						<Spinner tag="span" />
					</span>
				)}
				{children}
			</>
		</button>
	);
});

export * from "./types";
